import { StatementEvent } from '../../../model/interfaces';
import { ColumnType } from '@base/ui/components/dataTable';
import React from 'react';

const statementColumns: ColumnType<StatementEvent>[] = [
  {
    title: 'event',
    dataIndex: 'event',
    render: (statement) => (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ textAlign: 'left', marginRight: '1rem' }}>
          {statement.event}
        </span>
        <span style={{ textAlign: 'right' }}>{statement.transTime}</span>
      </div>
    ),
  },
  {
    title: 'entry_fee',
    dataIndex: 'fee',
    style: { width: '4rem' },
  },
  {
    title: 'ladder_points',
    dataIndex: 'pointsStamp',
    style: { width: '4rem' },
  },
  {
    title: 'ladder_setup',
    dataIndex: 'rankFrom',
    render: (statement) => (
      <span>
        {statement.rankFrom} {statement.rankFrom && '>'} {statement.rankTo}
      </span>
    ),
    style: { width: '4.5rem' },
  },
];

export default statementColumns;
